import React from 'react';
import cn from 'classnames';
import styles from './modal.module.css';
import Loader from '@components/common/Loader';

const Modal = ({
  isOpen,
  children,
  customClass,
  customClass2,
  customClass3,
  loading,
  isModalCenter,
  noBackground,
  style,
  customWidth
}) => {
  return (
    <div className="">
      {loading
      && <div><Loader /></div>}
      <>
        <div className={cn('modal', isOpen ? 'fade show d-block' : 'fade', customClass, styles.popupFlow,)}>
          <div className={cn(customWidth? styles.customWidth : styles.modalDialog, isModalCenter ? styles.modalDialogCentered : styles.modalDialogTop, customClass2)} role="document">
            <div className={cn(noBackground ? 'modal-content od-text-primary text-primary' : 'modal-content od-app-background-color background-primary od-text-primary text-primary', customClass3)} style={style}>
              {children}
            </div>
          </div>
        </div>
      </>
    </div>
  );
};
export default Modal;
